<section fxFlex fxLayout="column" fxLayoutAlign="center center">
  @if (authenticatingTid) {
    <forge-card>
      <div fxLayout="column" fxLayoutAlign="center center">
        <forge-circular-progress diameter="diameter" stroke-width="stroke"></forge-circular-progress>
        <span class="forge-typography--body2 busy-message">Authenticating...</span>
      </div>
    </forge-card>
  }


  @if (!hidden) {
    <div fxLayout="column" class="loginBox">
      <forge-card fxLayout="column">
        <div fxLayout="column" fxLayoutAlign="start stretch">
          <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
            <img src="/library/tylerui/images/tyler_logo.png" style="width: 120px;" alt="Tyler Technologies">
            <h1 class="forge-typography--heading7" style="margin: 0; color: var(--forge-theme-text-high);">{{productText}}</h1>
          </div>
          <div fxLayout="column" fxLayoutAlign="space-around center" class="tt-margin--top tt-margin--bottom">
            <div class="forge-typography--heading1">
              {{SubHeader}}
            </div>
          </div>
          @if (useTylerId && !IsMigrateTidUser) {
            <div fxLayout="column" fxLayoutAlign="center center">
              @if (!error) {
                <div fxLayout="column" fxLayoutAlign="center center">
                  <div>Authenticating with Tyler Identity</div>
                  <forge-circular-progress diameter="diameter" stroke-width="stroke"></forge-circular-progress>
                </div>
              } @else {
                <div class="error-text">
                  Invalid username or password
                </div>
              }
            </div>
          }
          @if (!busy) {
            @if (IsLogin) {
              <login-form [formType]="formType" [isDisabled]="isDisabled"
                [showForgotPwLink]="showForgotPwLink" [showRememberMe]="showRememberMe"
                (goto)="onGoto($event)">
              </login-form>
            }
            @if (IsSignout) {
              <signout-form>
              </signout-form>
            }
            @if (IsMigrateTidUser) {
              <migrate-tid-form [isDisabled]="isDisabled" (goto)="onGoto($event)">
              </migrate-tid-form>
            }
            @if (IsForgotPassword) {
              <forgot-password-form (goto)="onGoto($event)">
              </forgot-password-form>
            }
            @if (IsChangePassword) {
              <change-password-form (goto)="onGoto($event)">
              </change-password-form>
            }
            @if (IsResetPassword) {
              <reset-password-form>
              </reset-password-form>
            }
          }
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="margin-8">
          @if (version) {
            <div>{{version}}</div>
          }
          <div>{{tenant}}</div>
        </div>
      </forge-card>
    </div>
  }
</section>

